import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom';
import AppSidebar from "../utils/app/sidebar"
import "../utils/style.css"
import { Navigate } from 'react-router-dom';
import Image from 'helpers/Image';
import globalRouter from "globalRouter.ts";

function AppLayout({ profileData, initialRefetch }) {
    const auth = localStorage.getItem("token") ? true : false;
    const isSecurity = (localStorage.getItem("role") === 'SECURITY');

    // Desktop collapse (icon rail) — persisted. Mobile off-canvas drawer.
    const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sidebarCollapsed") === "1");
    const [mobileOpen, setMobileOpen] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed((prev) => {
            localStorage.setItem("sidebarCollapsed", prev ? "0" : "1");
            return !prev;
        });
    };
    const closeMobile = () => setMobileOpen(false);

    useEffect(() => {
        initialRefetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [logout, setLogout] = useState(false);
    const timeout = 3600000; // 1 hour in milliseconds

    useEffect(() => {
        let timer;
        const resetTimer = () => {
            clearTimeout(timer);
            timer = setTimeout(() => setLogout(true), timeout);
        };
        const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
        const resetEvents = () => {
            events.forEach(event => window.addEventListener(event, resetTimer));
        };
        resetTimer();
        resetEvents();
        return () => {
            clearTimeout(timer);
            events.forEach(event => window.removeEventListener(event, resetTimer));
        };
    }, [timeout]);

    useEffect(() => {
        if (logout) {
            localStorage.removeItem('token');
            globalRouter.navigate("/login", { state: { message: "Session Time Out! Please ReLogin." } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logout]);

    if (auth && isSecurity) {
        return <Navigate to="/security/dashboard" replace={true} />
    }

    return auth ? (
        <div className={`ers-shell${collapsed ? ' is-collapsed' : ''}${mobileOpen ? ' is-mobile-open' : ''}`}>
            {/* Mobile top bar */}
            <div className="ers-topbar">
                <button className="ers-burger" onClick={() => setMobileOpen(true)} aria-label="Open menu">
                    <Image name="menubar.svg" />
                </button>
                <Image name="ast-logo.png" className="ers-topbar-logo" />
            </div>

            {/* Backdrop for mobile drawer */}
            <div className="ers-backdrop" onClick={closeMobile} />

            <aside className="ers-sidebar">
                <AppSidebar
                    profileData={profileData}
                    collapsed={collapsed}
                    onToggle={toggleCollapsed}
                    closeMobile={closeMobile}
                />
            </aside>

            <main className="ers-main">
                <div className="ers-page">
                    <Outlet />
                </div>
            </main>
        </div>
    ) : <Navigate to="/" replace={true} />
}
export default AppLayout;
